import { create } from "zustand";
import type { Marker } from "../types/domain.types";

interface MarkerState {
  markers: Marker[];
  isLoading: boolean;
  error: string | null;
  setMarkers: (markers: Marker[]) => void;
  addMarker: (marker: Marker) => void;
  updateMarker: (id: string, patch: Partial<Marker>) => void;
  updateMarkers: (ids: string[], patch: Partial<Marker>) => void;
  removeMarker: (id: string) => void;
  setLoading: (loading: boolean) => void;
  setError: (error: string | null) => void;
  clear: () => void;
}

export const useMarkerStore = create<MarkerState>((set) => ({
  markers: [],
  isLoading: false,
  error: null,
  setMarkers: (markers) => set({ markers }),
  addMarker: (marker) =>
    set((s) => ({ markers: [marker, ...s.markers] })),
  updateMarker: (id, patch) =>
    set((s) => ({
      markers: s.markers.map((m) => (m.id === id ? { ...m, ...patch } : m)),
    })),
  updateMarkers: (ids, patch) =>
    set((s) => ({
      markers: s.markers.map((m) =>
        ids.includes(m.id) ? { ...m, ...patch } : m,
      ),
    })),
  removeMarker: (id) =>
    set((s) => ({
      markers: s.markers.filter((m) => m.id !== id),
    })),
  setLoading: (isLoading) => set({ isLoading }),
  setError: (error) => set({ error }),
  clear: () => set({ markers: [], error: null, isLoading: false }),
}));
